import { TASKS_LIST_API } from '../../../constants/api'
import { postApi } from '../../../utils/api'

import { getRequestProfileOpenActivitiesApiParams } from './RequestProfileOpenActivities.utils'

export function getRequestProfileOpenActivities(params) {
  return postApi({
    data: getRequestProfileOpenActivitiesApiParams(params),
    endpoint: TASKS_LIST_API,
  })
}
